import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 Not Found page
 */
export const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Page not found</p>
        <Link
          to="/dashboard"
          className="px-6 py-2 bg-accent text-white rounded-lg hover:bg-blue-600 transition"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};
